module.exports = "<div id=app> <div class=progress-bg v-if=showStep> <div class=progress :style=\"{ width : progress + '%'}\"> </div> </div> <components :is=currentView transition=slid> </components> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 62
 ** module chunks = 1
 **/